import { useEffect, useRef, useState } from 'react'
import Container from './container'

export default function Numeros() {
  const [projectsCount, setProjectsCount] = useState(0)
  const [solutionsCount, setSolutionsCount] = useState(0)
  const [collaboratorsCount, setCollaboratorsCount] = useState(0)
  const sectionRef = useRef(null)
  const animationTriggered = useRef(false)

  const targetCounts = {
    projects: 2000,
    solutions: 200,
    collaborators: 97,
  }

  const startCountAnimation = () => {
    if (animationTriggered.current) return

    animationTriggered.current = true

    const duration = 2000 // 2 seconds for the animation
    const framesPerSecond = 60
    const totalFrames = (duration / 1000) * framesPerSecond

    let frame = 0

    const interval = setInterval(() => {
      frame++
      const progress = frame / totalFrames

      if (progress >= 1) {
        setProjectsCount(targetCounts.projects)
        setSolutionsCount(targetCounts.solutions)
        setCollaboratorsCount(targetCounts.collaborators)
        clearInterval(interval)
        return
      }

      // Easing function for smoother animation
      const easeOutQuad = t => t * (2 - t)
      const easedProgress = easeOutQuad(progress)

      setProjectsCount(Math.round(easedProgress * targetCounts.projects))
      setSolutionsCount(Math.round(easedProgress * targetCounts.solutions))
      setCollaboratorsCount(
        Math.round(easedProgress * targetCounts.collaborators),
      )
    }, 1000 / framesPerSecond)
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const [entry] = entries
        if (entry.isIntersecting) {
          startCountAnimation()
        }
      },
      { threshold: 0.2 },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current)
      }
    }
  }, [])

  return (
    <div ref={sectionRef} className="w-full bg-[#040116] relative">
      <Container className="md:py-32 px-6">
        <section className="relative hidden lg:block">
          <div className="absolute left-2 -top-16 lg:-top-8 text-white z-10 text-center lg:text-start">
            <h3 className="text-[#C090F2] font-raleway_bold text-lg md:text-xl mb-4 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
              SEGMENTOS
              <br />
              ATENDIDOS
            </h3>
            <ul className="space-y-1 font-inter-semibold text-xs md:text-[16px]">
              <li>FINANCEIRO</li>
              <li>AGRONEGÓCIOS</li>
              <li>SAÚDE</li>
              <li>TELECOM</li>
              <li>UTILITIES</li>
              <li>COOPERATIVO</li>
              <li>VAREJO</li>
            </ul>
          </div>
          {/* Center - Image */}
          <div className="flex justify-center">
            <img
              src="/assets/numbers.png"
              alt="Team collaboration"
              className="rounded-lg h-[600px] lg:h-auto object-cover"
            />
          </div>
          {/* Solutions counter - Bottom Left */}
          <div className="absolute -bottom-16 -left-4 lg:-bottom-8 lg:left-[14%] max-w-[220px] bg-[rgba(255,255,255,0.09)] backdrop-blur-md p-6 rounded-lg text-white z-10">
            <div className="text-[#C090F2] text-2xl md:text-5xl font-poppins-medium mb-2 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
              +{solutionsCount}
            </div>
            <div className="font-inter-semibold uppercase tracking-widest text-xs md:text-sm">
              SOLUÇÕES DISPONÍVEIS PARA IMPULSIONAR SEUS NEGÓCIOS
            </div>
          </div>
          {/* Projects counter - Top Right */}
          <div className="absolute -top-12 -right-4 lg:right-0  w-fit bg-[#FFFFFF17] backdrop-blur-sm p-6 rounded-lg text-white z-10">
            <div className="text-[#C090F2] text-2xl md:text-5xl font-poppins-medium mb-2 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
              +{projectsCount}
            </div>
            <div className="font-inter-semibold uppercase tracking-widest text-xs md:text-sm">
              DE PROJETOS DESENVOLVIDOS
            </div>
          </div>
          <div className="absolute right-0 lg:bottom-4 rounded-lg text-white z-10">
            <div className="text-[#C090F2] text-2xl md:text-5xl font-poppins-medium mb-2 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
              +{collaboratorsCount}
            </div>
            <div className="font-inter-semibold uppercase tracking-widest text-xs md:text-sm">
              COLABORADORES
            </div>
          </div>
        </section>
        <section className="relative space-y-5 lg:hidden">
          <section className="relative flex flex-col gap-5">
            <div className="text-white">
              <h3 className="text-[#C090F2] font-raleway_bold text-lg md:text-xl mb-4 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
                SEGMENTOS ATENDIDOS
              </h3>
              <p className="font-inter-semibold text-xs uppercase">
                FINANCEIRO | AGRONEGÓCIOS | SAÚDE | TELECOM | UTILITIES |
                COOPERATIVO | VAREJO
              </p>
            </div>
            <img
              src="/assets/numbers.png"
              alt="Team collaboration"
              className="rounded-4xl object-cover aspect-square"
            />

            <div className="absolute -bottom-[20%] md:-bottom-16 -right-3 max-w-[175px] md:max-w-[220px] bg-[rgba(255,255,255,0.09)] backdrop-blur-md p-4 md:p-6 rounded-lg text-white z-10">
              <div className="text-[#C090F2] text-4xl font-poppins-medium mb-2 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
                +{solutionsCount}
              </div>
              <div className="font-inter-semibold uppercase tracking-widest text-xs md:text-sm">
                SOLUÇÕES DISPONÍVEIS PARA IMPULSIONAR SEUS NEGÓCIOS
              </div>
            </div>

            <div className="absolute top-[50%] -translate-y-[50%] -left-3 w-fit bg-[#FFFFFF17] backdrop-blur-sm p-6 rounded-lg text-white z-10">
              <div className="text-[#C090F2] text-3xl font-poppins-medium mb-2 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
                +{projectsCount}
              </div>
              <div className="font-inter-semibold uppercase tracking-widest text-xs md:text-sm">
                DE PROJETOS <br /> DESENVOLVIDOS
              </div>
            </div>

            <div className="absolute -bottom-20 left-6 rounded-lg text-white z-10">
              <div className="text-[#C090F2] text-4xl font-poppins-medium mb-2 drop-shadow-[0_0_5px_rgba(192,144,242,0.7)] text-glow">
                +{collaboratorsCount}
              </div>
              <div className="font-inter-semibold uppercase tracking-widest text-xs md:text-sm">
                COLABORADORES
              </div>
            </div>
          </section>
        </section>
      </Container>
    </div>
  )
}
